import {remCalc} from '_themeUtils'

const filtersList = {
    FiltersList: {
        baseStyle: () => ({
            headerWrapper: {
                w: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            },
            headerTitle: {
                textStyle: 'displayXs',
                fontWeight: 400,
            },
            footerWrapper: {
                w: '100%',
                gap: 'spacing.6',
            },
            footerButtons: {
                letterSpacing: remCalc(2.4),
            },
            accordionButton: {
                pr: {base: 'spacing.2', md: 'spacing.4'},
                py: {base: 'spacing.6', md: remCalc(26)},
            },
            filterText: {
                w: '100%',
                textStyle: {base: 'displayXs', md: 'paragraphMd'},
                letterSpacing: {base: remCalc(1), md: remCalc(0.6)},
                fontWeight: '400',
                pl: {base: 'spacing.6', md: 'spacing.none'},
            },
            closeIcon: {
                cursor: 'pointer',
            },
            accordionWrapper: {
                px: {base: 'spacing.4', md: 'spacing.none'},
                overflow: 'auto',
            },
            inlineFilter: {
                py: {base: 'spacing.4', md: remCalc(18)},
                borderTop: 'none',

                // disable animations on icons
                '& svg': {
                    transition: 'none !important',
                    transform: 'none !important',
                },
            },
            inlineFilterChildren: {
                flexGrow: 0,
                flexShrink: 1,
                flexBasis: 'auto',
            },
            filterItem: {
                px: {base: 0, md: 'spacing.6'},
                borderTop: 'none',
            },
            filterValuePreview: {
                mr: 'spacing.4',
            },
            filtersRadio: {
                '& .radio__label': {
                    fontWeight: 300,
                },
            },
        }),
    },
}

export default filtersList
